import { ca } from '@cian/analytics';
import { getClientDeviceType } from '../../../../../../shared/utils';

export const trackAddressSuccess = (isNewOffer) => {
  ca('eventSite', {
    name: 'oldevent',
    category: isNewOffer ? 'New_ad' : 'Edit_ad',
    action: 'GEO',
    label: 'address_success',
  });
};

export const trackAddressError = (isNewOffer, errorCode) => {
  const siteType = getClientDeviceType();

  ca('eventSite', {
    name: 'oldevent',
    category: isNewOffer ? 'New_ad' : 'Edit_ad',
    action: 'GEO',
    label: 'address_error',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: errorCode,
    }
  });
};
